import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import './styles/global.css'
import App from './App.jsx'
import './styles/theme-overrides.css'
import './styles/dopamine-overrides.css'
import './styles/mobile-responsive.css'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
